import type { FC, ReactNode } from 'react'
import { useLocalisation } from '@/tools/i18n/client'
import { BenchIcon, BuildingsIcon, HouseIcon, IconSize, MonitorIcon } from '@/tools/ui'
import type { UserAddressKind } from '@/user/address-book/entities'

interface Props {
  addressKind: UserAddressKind
}

export const AddressItemCardIcon: FC<Props> = ({ addressKind }) => {
  const { t } = useLocalisation()

  const size = IconSize.medium
  const translateKeys = {
    HOUSE: t('address-type.house'),
    APARTMENT: t('address-type.apartment'),
    OFFICE: t('address-type.office'),
    OTHER: t('address-type.other'),
  }
  const addressKindIconMap: Record<UserAddressKind, () => ReactNode> = {
    HOUSE: () => <HouseIcon data-testid="HOUSE" outline={true} size={size} />,
    APARTMENT: () => <BuildingsIcon data-testid="APARTMENT" outline={true} size={size} />,
    OFFICE: () => <MonitorIcon data-testid="OFFICE" outline={true} size={size} />,
    OTHER: () => <BenchIcon data-testid="OTHER" outline={true} size={size} />,
  }

  const AddressKindIcon = addressKindIconMap[addressKind]
  return (
    <div aria-label={translateKeys[addressKind]} role="img">
      <AddressKindIcon />
    </div>
  )
}
